import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { AcrossIframeModule } from '../../core/components/across-iframe/across-iframe.module';
import { AuthorizedComponent } from './widgets/authorized/authorized.component';
import { CommonModule } from '@angular/common';
import { CopyrightModule } from '../../core/components/copyright/copyright.module';
import { FormFieldsModule } from '../../core/form-fields/form-fields.module';
import { HeaderModule } from '../../core/components/header/header.module';
import { LoginPageComponent } from './login-page.component';
import { LoginRoutingModule } from './login-routing.module';
import { LottieComponent } from 'ngx-lottie';
import { NgModule } from '@angular/core';
import { NotificationsModule } from '../../core/components/notifications/notifications.module';
import { ResetPasswordComponent } from './widgets/reset-password/reset-password.component';
import { RouterModule } from '@angular/router';
import player from 'lottie-web';
import { P500UIFormFieldsModule, P500UITooltipModule } from '@platform500services/p500-ui-kit';

export function playerFactory() {
  return player;
}

@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    RouterModule,
    LoginRoutingModule,
    FormFieldsModule,
    NotificationsModule,
    CopyrightModule,
    AcrossIframeModule,
    HeaderModule,
    LottieComponent,
    P500UIFormFieldsModule,
    P500UITooltipModule,
  ],
  declarations: [LoginPageComponent, AuthorizedComponent, ResetPasswordComponent],
})
export class LoginModule {}
